/**
 * Properties of a request to Verify access/whether you are allowed to execute actions on the request for FE checking
 */
export class BaseAccessPropertiesRequestClass {
    /**
     * Unique Guid of the owner of the request
     */
    ownerGuid!: string;
    /**
     * Information about the workgroup of the request
     */
    workgroupGuid: string = "";
    /**
     * Information about the clearancelevel of the request
     */
    clearancelevel: number = 1;

}